import { useState, useEffect } from 'react';
import { supabase } from '@/integrations/supabase/client';

interface ProjectTabsConfig {
  ai_projects_advisor: boolean;
  cost_analysis: boolean;
}

export const useProjectTabs = () => {
  const [config, setConfig] = useState<ProjectTabsConfig>({
    ai_projects_advisor: true,
    cost_analysis: true
  });
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const fetchProjectTabs = async () => {
      try {
        setIsLoading(true);
        setError(null);

        const { data, error: fetchError } = await supabase
          .from('project_tabs')
          .select('ai_projects_advisor, cost_analysis')
          .limit(1)
          .single();

        if (fetchError) {
          console.error('Error fetching project tabs:', fetchError);
          setError('Failed to fetch project tabs configuration');
          return;
        }

        if (data) {
          setConfig({
            ai_projects_advisor: data.ai_projects_advisor || false,
            cost_analysis: data.cost_analysis || false
          });
        }
      } catch (error) {
        console.error('Error in fetchProjectTabs:', error);
        setError('Failed to fetch project tabs configuration');
      } finally {
        setIsLoading(false);
      }
    };

    fetchProjectTabs();
  }, []);

  return { config, isLoading, error };
};